export function Sparkline({
  values,
  color = "currentColor",
  className = "",
  animated = true,
}: {
  values: number[];
  color?: string;
  className?: string;
  animated?: boolean;
}) {
  const w = 100,
    h = 30,
    pad = 2;
  const min = Math.min(...values),
    max = Math.max(...values),
    range = max - min || 1;
  const step = (w - 2 * pad) / (values.length - 1);
  const pts = values.map((v, i) => [pad + i * step, pad + (1 - (v - min) / range) * (h - 2 * pad)]);
  const d = pts.map((p, i) => `${i === 0 ? "M" : "L"} ${p[0].toFixed(1)} ${p[1].toFixed(1)}`).join(" ");
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className={className} preserveAspectRatio="none">
      <path
        className={animated ? "spark-path" : undefined}
        d={d}
        fill="none"
        stroke={color}
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
